import { CircularProgress, Collapse, Divider, IconButton, Stack } from '@mui/material';
import { ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetHeader, WidgetPerCustomerBody, WidgetWrapper } from '../shared/all.styles';
import { Typography } from '../shared/typography';
import { ExpandLess, ExpandMore, Link } from '@mui/icons-material';
import { theme } from '../theme';
import { format } from 'date-fns/format';

interface Props {
  title: string;
  loading?: boolean;
  values?: any[];
  onLinkClick?: (filter?:any) => void;
}

export const WidgetNewestUpdatedClusters = ({
  title,
  values,
  loading,
  onLinkClick,
}: Props): ReactElement => {
  const { t } = useTranslation();

  return (
    <WidgetWrapper>
      <WidgetHeader>
        <Typography variant="subtitle2">{title}</Typography>

        {onLinkClick && (
          <IconButton onClick={() => onLinkClick()} color="primary" title="More">
            <Link />
          </IconButton>
        )}
      </WidgetHeader>
      {
        <Stack alignItems={'center'} paddingTop={'15px'} color={'success.main'} fontSize={'35px'}>
          <Typography color={'success.main'} variant="h4">
            {values?.length}
          </Typography>
        </Stack>
      }
      <WidgetPerCustomerBody>
        {loading ? (
          <CircularProgress size={50} />
        ) : (
          <Stack>
            {values?.length ? (
              values?.map((el) => (
                <CustomerItem key={el.descriptions} data={el} onLinkClick={onLinkClick} />
              ))
            ) : (
              <Typography color="success.main" variant="h5" fontWeight={500} fontSize={40}>
                {t('home.noData')}
              </Typography>
            )}
          </Stack>
        )}
      </WidgetPerCustomerBody>
    </WidgetWrapper>
  );
};

interface CustomerItemProps {
  data: any;
  onLinkClick?: (filter:any) => void;
}

const CustomerItem = ({ data, onLinkClick }: CustomerItemProps): ReactElement => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <Stack
      sx={{
        ':hover': {
          borderColor: 'primary.light',
        },
        border: '2px solid',
        borderColor: 'common.white',
        borderRadius: '10px',
      }}
      padding={'2px'}
      onClick={() => {}}
    >
      <Stack direction={'row'} justifyContent="space-between">
        <Stack direction={'row'} spacing={4} alignItems="center">
          <Typography>{data?.descriptions}</Typography>
          <IconButton onClick={() => setOpen((prev) => !prev)}>
            {open ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Stack>
        {onLinkClick && (
          <div style={{ marginRight: '15px' }}>
            <IconButton
              onClick={() => {
                return onLinkClick(data.cluster_id);
              }}
              color="primary"
              title="More"
            >
              <Link />
            </IconButton>
          </div>
        )}
      </Stack>
      <Collapse in={open}>
        <Stack paddingX={'0px'} direction={'row'} justifyContent={'space-between'} divider={<Divider flexItem orientation="horizontal" />}>
          {data?.has_review ? (
            <Typography color={theme.palette.warning.main}>{t('info.toReview')}</Typography>
          ) : (
            <Typography color={theme.palette.success.main}>{t('info.toNotReview')}</Typography>
          )}
          <Typography>{t('info.lastUpdate')}: {format(new Date(data?.updated_at), 'dd/MM/yyyy hh:mm')}</Typography>
        </Stack>
      </Collapse>
    </Stack>
  );
};
